import axios from 'axios';
import { apolloClient } from '@/apollo';
import { usersQuery, tagsQuery, entityQuery } from '@/graphql/queries/entity.queries';
import { ITeam } from '@/types/Team';
import { IUser } from '@/types/User';
import { ITag } from '@/types/Tag';
import { IPlanStatus } from '@/types/plan-status';
import { IEntity } from '@/types/Entity';

const fetchUsers = async (): Promise<IUser[]> => {
  const {
    data: { users },
  } = await apolloClient.query({
    query: usersQuery,
  });
  return users.map((user: IUser) => setUserName(user));
};

function setUserName(user: IUser): IUser {
  return { ...user, name: `${user.firstName} ${user.lastName}` };
}

const fetchEntityTags = async (): Promise<ITag[]> => {
  const {
    data: { tags = [] },
  } = await apolloClient.query({
    query: tagsQuery,
    fetchPolicy: 'network-only',
  });
  return tags;
};

const fetchTeams = async (): Promise<ITeam[]> => {
  const { data } = await axios.get('/get/settings/scope');
  return data.map(team => ({
    ...team[0],
    id: team[0].id || team[0].name,
  }));
};

const fetchTheme = async (): Promise<IEntity> => {
  const {
    data: { entity },
  } = await apolloClient.query({
    query: entityQuery,
    fetchPolicy: 'network-only',
  });
  return entity;
};

const fetchPlanStatus = async (): Promise<IPlanStatus> => {
  const { data } = await axios.get('/get/settings/plan-status');
  return {
    creditsLeft: data.credits_left,
    daysLeft: data.days_left,
    endDate: data.end_date,
    plan: data.plan,
    planTitle: data.plan_title,
  } as IPlanStatus;
};

const fetchEntity = async (): Promise<IEntity> => {
  const {
    data: { entity },
  } = await apolloClient.query({
    query: entityQuery,
    fetchPolicy: 'network-only',
  });
  return entity;
};

export default {
  fetchUsers,
  fetchEntityTags,
  fetchTeams,
  fetchTheme,
  fetchPlanStatus,
  fetchEntity,
};
